<template>
  <div class="me-toast__container">
    <transition-group name="slide-x" tag="div" appear>
      <div
        v-for="(toast, index) in toastList"
        :key="toast.id"
        :class="[
          'me-toast__item',
          `me-toast__item--${toast.class}`
        ]"
      >
        <svg class="ico ico--types">
          <use :xlink:href="`/images/svg-symbols.svg#${toast.icon}`"></use>
        </svg>
        <div v-html="toast.content" class="v-html-content"></div>
        <slot v-if="!toast.content"></slot>
        <svg
          @click="removeToast(index)"
          class="ico ico--close"
        >
          <use xlink:href="/images/svg-symbols.svg#remove"></use>
        </svg>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'meStackedToast',

  props: {
    content: {
      type: String,
      default: '',
      required: false
    },
    timeout: {
      type: Number,
      default: 5000,
    },
    type: {
      type: String,
      default: 'default',
    }
  },

  data(){
    return {
      ids: 0,
      toastList: [],
      toastConfigs: {
        info: {
          class: 'info',
          icon: 'toast-info',
        },
        success: {
          class: 'success',
          icon: 'approved',
        },
        danger: {
          class: 'danger',
          icon: 'error',
        },
        warning: {
          class: 'warning',
          icon: 'rejected',
        },
      },
    }
  },

  beforeUpdate() {
    /*
      check toasts timeout
      stop checking when list is empty and reset ids
    */
    this.toastList.length > 0 ?
      window.setTimeout(() => { this.checkToastTimeout() }, this.timeout) :
      (window.clearTimeout(), this.ids = 0);
  },

  methods: {
    createToast(content = this.content, type = this.type) {
      this.toastList.push(
        {
          id: this.ids++,
          isActive: true,
          createdAt: Date.now(),
          content,
          class: this.toastConfigs[type].class,
          icon: this.toastConfigs[type].icon,
        }
      )
    },
    checkToastTimeout() {
      if (this.timeout < 0) {
        return;
      }

      this.toastList = this.toastList.filter((toast) => {
        if(Date.now() - this.timeout> toast.createdAt) {
          toast.isActive = false;
        }
        return toast.isActive;
      });
    },
    removeToast(index) {
      this.toastList.splice(index, 1);
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~commons/stylus/core/_vars'

  // vue transition
  .slide-x

    &-enter-active
    &-leave-active
      transition all 1.2s

    &-enter
    &-leave-to
      opacity 0
      transform translateX(-50%)

    &-move
      transition transform .5s

  .me-toast

    &__container
      position fixed
      bottom 0
      left 1%
      z-index 9999

      @media screen and (max-width 768px)
        width calc(100% - 32px)
        top 0
        left 50%
        bottom initial
        transform translate(-50%)

      @media print
        display none

    &__item
      position relative
      display flex
      align-items center
      justify-content space-between
      max-width 388px
      padding 18px 20px
      margin 12px 0
      border-radius 4px
      background-color $curiousBlue
      box-shadow 2px 3px 5px -1px rgba(0,0,0,.2),
                 3px 6px 10px 0 rgba(0,0,0,.14),
                 4px 1px 18px 0 rgba(0,0,0,.12)
      line-height 1.45
      font-size 14px
      color #ffffff
      box-sizing border-box

      .ico
        flex-shrink 0
        display block
        fill #fff

        &--types
          align-self flex-start
          width 24px
          height 24px
          margin-top 4px
          margin-right 24px

        &--close
          position absolute
          top 12px
          right 12px
          width 8px
          height 8px
          cursor pointer

      .v-html-content
        padding-right 8px
        font-family Lato

        >>> .title
          font-weight bold
          font-size 14px

        >>> .subtitle
          font-size 12px

          a
            color #fff

      &--info
        background-color $curiousBlue

      &--success
        background-color $mrGreen

      &--danger
        background-color $dangerRed

      &--warning
        background-color $neonCarrot

</style>
